export const API_INFORMATION_LOADED = 'API_INFORMATION_LOADED';